import { ProfileAvatar, ProfileForm } from '@/features/profile';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { useSearchParams } from 'react-router-dom';
// import { useProfileFormStore } from '@/features/profile/stores/profileFormStore';
// import { useUser } from '@/queries/useUser';
// import { StanProfilePreview } from '@/components';

export default function ProfilePage() {
    const [searchParams] = useSearchParams();
    const isOnboardingSocialLinks = searchParams.get('onboarding') === 'social-links';
    // const { user } = useUser();
    // const form = useProfileFormStore(state => state.form);
    // const displayName = form?.watch('displayName');
    // const bio = form?.watch('bio');
    // const socialLinks = form?.watch('socialLinks');

    useBreadcrumbs([
        { title: 'My Store', to: '/stores', active: false, id: 'home' },
        { title: 'Header', to: '/profile', active: true, id: 'profile' },
    ]);

    return (
        <div className='mx-auto w-full max-w-screen-md pb-6'>
            <div className='bg-canvas shadow-stan rounded-lg'>
                <div className='space-y-4 p-6 md:space-y-10 md:p-8'>
                    {!isOnboardingSocialLinks && <ProfileAvatar />}
                    <ProfileForm hideBasicInfo={isOnboardingSocialLinks} />
                </div>
            </div>

            {/* Preview Panel - Commented out for now */}
            {/* <div className='mt-6'>
                <div className='bg-canvas rounded-lg shadow-md'>
                    <div className='border-neutral-subtle border-b px-6 py-4'>
                        <h2 className='text-heading-h3 text-dark'>Preview</h2>
                    </div>
                    <div className='p-6'>
                        <StanProfilePreview
                            avatar={user?.profile_image || ''}
                            displayName={displayName || user?.full_name || 'Display Name'}
                            bio={bio}
                            socialLinks={socialLinks}
                        />
                    </div>
                </div>
            </div> */}
        </div>
    );
}
